module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBestseller.461b855.webp";